import { useMemo } from "react";

export default function useFlattenedStudents({ mode, groupData, selectedEpr, existingRatingsData }) {
    return useMemo(() => {
        if (mode === "GROUPS") {
            return groupData.flatMap((group) =>
                group.groupStudentContents.map((student) => ({
                    key: `${group.groupId}-${student.gradingProfileStudentId}`,
                    contentRatings: student.contentRatings || [],
                    contentStudentComments: student.contentStudentComments || null,
                    firstName: student.firstName,
                    gradingProfile: group.gradingProfileId,
                    gradingProfileStudentId: student.gradingProfileStudentId,
                    groupHomeroomTeacher: group.teacherName,
                    groupId: group.groupId,
                    groupName: group.groupName,
                    groupPermission: group.permission,
                    isShared: !!group.shareGroupId,
                    lastName: student.lastName,
                    sectionId: student.sectionId,
                    studentNumber: student.studentNumber
                }))
            );
        } else {
            const ratingMap = new Map((existingRatingsData || []).map((entry) => [entry.key, entry]));
            return (selectedEpr.gradingProfileStudents || []).map((student) => {
                const ratingEntry = ratingMap.get(student.key) || {};
                return {
                    key: student.key,
                    contentRatings: ratingEntry.contentRatings || [],
                    contentStudentComments: ratingEntry.contentStudentComments || null,
                    firstName: student.firstName,
                    gradingProfile: selectedEpr.key,
                    gradingProfileStudentId: student.key,
                    lastName: student.lastName,
                    sectionId: student.sectionId,
                    studentNumber: student.studentNumber
                };
            });
        }
    }, [mode, groupData, selectedEpr, existingRatingsData]);
}
